import { StatsContexter } from './contexter';
import { WindowService } from '../../service/window/service';

export function StatsContexterFactory(): StatsContexter {
  return new StatsContexter(WindowService());
}
